module.exports = __webpack_public_path__ + "img/lanhaicunzhujiangyou.dc22b306.png";